import { Box, Drawer, List, Toolbar } from '@mui/material'
import { TEST_IDS } from 'test-ids'

export default function CommonSidebar(props) {
  const { children, testId } = props
  const sidebarTestId = testId || TEST_IDS.commonSidebar
  var drawerWidth = 250

  return (
    <Drawer
      variant="permanent"
      className="sidePanelSidebar"
      style={{
        width: drawerWidth,
        flexShrink: 0,
      }}
      data-testid={sidebarTestId}
      slotProps={{
        paper: {
          sx: {
            zIndex: '999',
          },
        },
      }}
    >
      <Toolbar className="sidePanelSidebar" />
      <Box className="sidePanelSidebar" style={{ overflow: 'auto' }}>
        <List style={{ width: drawerWidth }}>{children}</List>
      </Box>
    </Drawer>
  )
}
